// Admin
import { Components as Dashboard } from 'modules/Admin/Dashboard';
import { Components as Profile } from 'modules/Admin/Profile';
import { Components as Accounts } from 'modules/Admin/Accounts';
import { Components as Companies } from 'modules/Admin/Companies';
import { Components as Employees } from 'modules/Admin/Employees';
import { Components as Inventory } from 'modules/Admin/Inventory';
import { Components as Reports } from 'modules/Admin/Reports';

// Public
import { PublicComponents } from 'modules/Public';

const routeComponents = [

  ...Dashboard,
  ...Profile,
  ...Accounts,
  ...Companies,
  ...Employees,
  ...Inventory,
  ...Reports,

  ...PublicComponents,

]
console.log('ROOT: Components', routeComponents)

export default routeComponents;
